import api from "./axiox";

export const createUser = async (user) => {
  const response = await api.post("/user/create", user);
  return response.data;
}; 